import styled from '@emotion/styled'
import { Select } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { DebounceSelect } from './AutoCompleteSearchUser'

export const SelectStyled = styled(Select)`
  .ant-select-selector {
    height: 44px !important;
    border-radius: 0px !important;
    align-content: center !important;
    align-items: center !important;
  }

  .ant-select-selection-search-input {
    height: 44px !important;
    align-items: center !important;
    align-content: center !important;
  }

  .ant-select-selection-item {
    align-content: center !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 20px !important;
  }
`

export const AntdDebounceSelect = styled(DebounceSelect)`
  width: 100%;
`

export const SearchIcon = styled(SearchOutlined)`
  color: #adadad;
`
